import { render, staticRenderFns } from "./AssessmentAnalysis.vue?vue&type=template&id=08342a5a"
import script from "./AssessmentAnalysis.vue?vue&type=script&lang=js"
export * from "./AssessmentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AssessmentAnalysis.vue?vue&type=style&index=0&id=08342a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports